import React from 'react';

const RadioButton = ({ label, value, checked, onChange }) => {
  return (
    <label className="inline-flex items-center border w-full cursor-pointer p-4">
      <input
        type="radio"
        value={value}
        checked={checked}
        onChange={onChange}
        className="form-radio h-5 w-5 text-blue-600"
      />
      <span className="ml-2 text-gray-700">{label}</span>
    </label>
  );
};

export default RadioButton;
